export default __webpack_public_path__ + "static/real3-eaaec28c92d1f18c0216f721aeaf995e.png";